import ReactGA from "react-ga";
// import Utils from "../../../utils/utils";

/**
 * 不同语种的产品ID列表
 */
const pidMap = new Map([
  ["ar", "4069"],
  ["br", "4068"],
  ["cn", ""], //暂时没有具体产品
  ["de", "4075"],
  ["es", "4073"],
  ["en", "4011"],
  ["fr", "4072"],
  ["id", "4079"],
  ["in", "4078"],
  ["it", "4070"],
  ["jp", "4076"],
  ["kr", "4067"],
  ["nl", "4074"],
  ["ru", "4071"],
  ["tr", "4080"],
  ["tw", "4077"],
]);

let afirstsofeData = {
  //公共信息
  common: {
    // pid: pidMap.get(Utils.getLanguage()), //产品id
    channel: "SEO", //渠道
    os: window.userClient, //操作系统
    os_version: navigator.userAgent, //操作系统版本号
    web: window.location.origin,
    // product: "HitPawOnline", //产品名称
    // product_version: "1.7.0", //产品版本号
    uid: "", //用户id
    session_id: "", //当前产品的会话id
    ip: "", //ip地址
    brand: "", //手机品牌/电脑品牌
    model: "", //手机型号/电脑型号
    is_new: "", //是否首日使用，当日首次使用， 该字段值为1，当日其他情况为0。
    mac: "", //设备id/mac地址
    country: "", //国家
    region: "", //地区(省/州)
    city: "", //城市
    email: "", //邮箱
    phone: "", //电话
  },
  page: {
    page_id: window.location.href,
  },
  ts: new Date().valueOf(),
};

/**
 * 将数据报给公司大数据后台的方法
 * @param {*} param0
 */
const sentAfirstsofe = ({ category, action, label }) => {
  let data = {
    ...afirstsofeData,
    //动作(事件)
    actions: {
      event_label: label, //事件标签
      event_type: "event", //事件类型
      event_category: category, //事件类别
      event_action: action, //事件活动
    },
  };
  fetch("https://analytics.afirstsoft.cn/collect", {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "content-type": "application/json",
    },
  })
    .then(res => {
      console.log(res);
    })
    .catch(err => console.log(err));
};

/**
 * 发送GA埋点事件
 */
const sentGAEvent = actions => {
  ReactGA.event(
    {
      ...actions,
    },
    ["AccountTracker"]
  );
  sentAfirstsofe(actions);
};

export default sentGAEvent;
